import { render, staticRenderFns } from "./updateLiaison.vue?vue&type=template&id=14a42133&scoped=true&"
import script from "./updateLiaison.vue?vue&type=script&lang=js&"
export * from "./updateLiaison.vue?vue&type=script&lang=js&"
import style0 from "./updateLiaison.vue?vue&type=style&index=0&id=14a42133&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a42133",
  null
  
)

export default component.exports